import { render, staticRenderFns } from "./AdminArticles.vue?vue&type=template&id=2f354082&scoped=true"
import script from "./AdminArticles.vue?vue&type=script&lang=js"
export * from "./AdminArticles.vue?vue&type=script&lang=js"
import style0 from "./AdminArticles.vue?vue&type=style&index=0&id=2f354082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f354082",
  null
  
)

export default component.exports